export default __webpack_public_path__ + "static/ActivityCardWorkplace-99f99a32aa15c6c959066424e4e8bfa1.png";